import { Component, Input, OnInit } from '@angular/core';
import { BaseHtmlHelperComponent } from '../../base/base.htmlhelper.component';
import { Router, ActivatedRoute } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { SessionCreditVM } from '../../../models/SessionCreditVM';

@Component({
  selector: 'redeem-session-list',
  templateUrl: './redeem-session-list.component.html'
})
export class RedeemSessionListComponent extends BaseHtmlHelperComponent implements OnInit {

  @Input() status: boolean = true; //active by default
  credits: SessionCreditVM[] = [];

  constructor(private router: Router, private route: ActivatedRoute, private accService: AccountService) {
    super();
  }

  ngOnInit(): void {
    this.accService.getSessionCredits(this.status)
      .subscribe(
        r => this.credits = r,
        e => {
          console.log(e);
        }
      );
  }

  redeem(item: SessionCreditVM) {
    this.emitDisplayLoadingDialog(true);
    this.router.navigateByUrl('/redeem-session/' + item.id);
  }

}
